// extracted by mini-css-extract-plugin
export default {"image":"f5-z","loaded":"g5-z"};